<template>
  <CollapsibleCard
    :value="true"
    collapsibleIcon="mdi-home-city-outline"
    collapsibleTitle="Prosjekt info"
    :padding="true"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-autocomplete
          v-model="data.projTable"
          :items="projects"
          color="primary"
          label="Prosjekt"
          item-text="value"
          item-value="key"
          filled
          hide-details="auto"
          clearable
          :rules="[(v) => !!v || 'Prosjekt må velges ut!']"
          @change="getHouseAndSection"
        ></v-autocomplete>

        <v-select
          v-model="data.projPhase"
          class="mb-5"
          :items="houses"
          hide-details
          filled
          label="Bygg"
          item-text="name"
          item-value="id"
          clearable
          @change="changeHouse"
        ></v-select>

        <v-select
          v-model="data.projSectionId"
          class="mb-5"
          :items="sectionsFiltred"
          hide-details
          filled
          label="Seksjon"
          item-text="sectionNum"
          item-value="id"
          clearable
          @change="changeSection"
        >
          <template v-slot:item="{ item }">
            <div>
              Seksjon {{ item.sectionNum }}
              {{ item.customer ? `(${item.customer})` : `` }}
            </div>
          </template>
        </v-select>

        <v-select
          v-model="data.location"
          class="mb-5"
          :items="aberrationLocations"
          hide-details
          filled
          label="Sted"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-form>
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import projectApi from "@/api/projectApi";
export default Vue.extend({
  name: "AberrationProjectCard",
  props: {
    value: {},
    type: {
      type: Array,
    },
    projects: {
      type: Array,
    },
    aberrationLocations: {
      type: Array,
    },
  },
  data() {
    return {
      valid: true,
      houses: [],
      sections: [],
    };
  },
  mounted() {
    if (this.$route.query.projectId) {
      this.getHouseAndSection(this.$route.query.projectId);
    }
  },
  methods: {
    validate() {
      return (this as any).$refs.form.validate();
    },
    getHouseAndSection(projectId) {
      if (projectId) {
        projectApi.getProjectHouses(projectId).then((r) => {
          this.houses = r;
        });

        projectApi.getProjectSections(projectId).then((r) => {
          this.sections = r;
        });
      } else {
        delete (this as any).data.projPhase;
        delete (this as any).data.projSectionId;
        this.houses = [];
        this.sections = [];
      }
    },
    changeHouse(houseId) {
      if (!houseId) {
        delete (this as any).data.projSectionId;
      }
    },
    changeSection(sectionId) {
      if (sectionId) {
        sectionId;
        var section = (this as any).sections.find((x) => x.id === sectionId);

        (this as any).data.projPhase = section.houseId;
      }
    },
  },
  computed: {
    data: {
      get(): any {
        return this.value;
      },
    },
    sectionsFiltred(): Array<any> {
      if ((this as any).data.projPhase) {
        return (this as any).sections.filter(
          (x) => x.houseId === (this as any).data.projPhase
        );
      }
      return this.sections;
    },
  },
  components: {
    CollapsibleCard,
  },
});
</script>
